import { Component, computed, inject, input, linkedSignal } from '@angular/core';
import { cva } from 'class-variance-authority';

import { CroisementÉtat } from '../../models/croisement-état';
import { ConvertEtatToStringPipe } from '../../pipes/convert-croisement-etat-to-string.pipe';

const listVariants = cva('text-grey-10 py-xs px-sm paragraph-medium-medium rounded-full text-center', {
  variants: {
    variant: {
      [CroisementÉtat.A_FAIRE]: 'bg-feedback-warning-lightest',
      [CroisementÉtat.EN_COURS]: 'bg-feedback-informative-lightest',
      [CroisementÉtat.TERMINE]: 'bg-feedback-positive-lightest',
    },
  },
});

@Component({
  selector: 'app-croisement-etat',
  template: `
    <div>
      <span [class]="_computedClass()">{{ etatStr() }}</span>
    </div>
  `,
  providers: [ConvertEtatToStringPipe],
})
export class CroisementÉtatComponent {
  readonly #convertBlocEtatToStringPipe = inject(ConvertEtatToStringPipe);

  readonly etat = input<CroisementÉtat>();

  readonly etatStr = linkedSignal(() => this.#convertBlocEtatToStringPipe.transform(this.etat()));

  protected readonly _computedClass = computed(() => listVariants({ variant: this.etat() }));
}
